async function checkRestrictions() {
    const buttons = document.querySelectorAll('.tocheckvendor');
    buttons.forEach(button => {
        const vendor = button.getAttribute('data-product-vendor');
        if (vendor !== 'Goddiva' && vendor !== 'Goddiva Plus' && vendor !== 'Danaya' && vendor !== 'Cosmochic' && vendor !== 'City Goddess') {
            fetch('https://pro.ip-api.com/json/?key=XjCy8wkn8k9YuLG&fields=status,country,countryCode')
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        if (data.countryCode !== 'GB') {
                            const cardAction = button.closest('.card-action'); 
                            if (cardAction) {
                                const quickshopQuantity = cardAction.querySelector('.quickshop-quantity'); 
                                if (quickshopQuantity && !quickshopQuantity.hasAttribute('data-uk-shipping-message')) { 
                                    quickshopQuantity.insertAdjacentHTML('afterend', '<div class="uk-shipping-message">'+window.restricted_warning_message_collection +'</div>');
                                    quickshopQuantity.setAttribute('data-uk-shipping-message', 'true'); 
                                }
                            }
                        }
                    } else {
                        console.error('Failed to fetch user country information');
                    }
                })
                .catch(error => {
                    console.error('Error fetching user country:', error);
                });
        } else {
            // Do nothing if vendor is one of the specified ones
        }
    });
}

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.body.classList.contains('template-product')) {
    checkRestrictions();
  }
});